import {useEffect,useState} from 'react';
import {Check,Copy} from 'lucide-react';

export function CopyableCommand({value,label,displayValue,buttonText}) {
  const [copied,setCopied]=useState(false);
  const [error,setError]=useState('');
  useEffect(()=>{
    if(!copied) return;
    const timer=setTimeout(()=>setCopied(false),2500);
    return()=>clearTimeout(timer);
  },[copied]);
  async function copy() {
    try {await navigator.clipboard.writeText(value);setCopied(true);setError('');}
    catch {setError(displayValue?'Couldn’t copy. Show the connection URL, then select and copy it manually.':'Couldn’t copy. Select the text and copy it manually.');}
  }
  return <>
    <div className="pabs-install-command">
      <code>{displayValue || value}</code>
      <button type="button" className={buttonText?'pabs-install-copy-labeled':''} onClick={copy} aria-label={copied?'Copied':buttonText||label} title={copied?'Copied':buttonText||label}>
        {copied?<Check size={19} aria-hidden="true"/>:<Copy size={19} aria-hidden="true"/>}
        {buttonText && <span>{copied?'Copied':buttonText}</span>}
      </button>
    </div>
    <span className="pabs-install-sr-only" role="status">{copied?'Copied to clipboard.':''}</span>
    {error && <p className="pabs-install-copy-error" role="alert">{error}</p>}
  </>;
}
